import { render, staticRenderFns } from "./outboundMerchantData.vue?vue&type=template&id=127a6c8c&scoped=true"
import script from "./outboundMerchantData.vue?vue&type=script&lang=js"
export * from "./outboundMerchantData.vue?vue&type=script&lang=js"
import style0 from "./outboundMerchantData.vue?vue&type=style&index=0&id=127a6c8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127a6c8c",
  null
  
)

export default component.exports